import { BASE_URL } from '../shared/constant.js';

export const API_ENDPOINTS = {
  ACCOUNTS: {
    LOGIN: 'accounts/login/',
    LOGOUT: 'accounts/logout/',
    SIGNUP: 'accounts/platform-employee/signup/',
    PROFILE: 'accounts/profile/',
    PROTECTED: 'accounts/protected/',
    CHANGE_PIN: 'accounts/change-pin/',
    FORGOT_PIN: 'accounts/forgot-pin/',
    REQUEST_OTP: 'accounts/request-otp/',
    VERIFY_OTP: 'accounts/verify-otp/',
    TOKEN_REFRESH: 'accounts/token/refresh/',
    USER_LIST: 'accounts/userlist/',
    USER_LIST_EXPORT: 'accounts/userlist/export/',
    PROFILE_ACTIVE_STATUS: (profileId, role) => `accounts/profile/${profileId}/activestatus/`,
    USER_VERIFY_STATUS: (userId) => `accounts/user/${userId}/verifystatus/`,
    STATES: 'accounts/states/',
    DISTRICTS: (stateId) => `accounts/districts/${stateId}/`,
  },
  BUYERS: {
    SIGNUP: 'buyers/signup/',
    PROFILE: 'buyers/profile/',
    PROFILE_BY_ID: (buyerId) => `buyers/profile/${buyerId}/`,
    PROFILE_UPDATE: (buyerId) => `buyers/profile/${buyerId}/update/`,
    PROFILE_DELETE: 'buyers/profile/delete/',
    PROFILE_CHANGE_IMAGE: 'buyers/profile/changeimage/',
    INQUIRY_LIST: 'buyers/inquiry/list/',
    INQUIRY_SUBMIT: 'buyers/inquiry/submit/',
    INQUIRY_UPDATE: (id) => `buyers/inquiry/${id}/update/`,
    INQUIRY_PDF: (id) => `buyers/inquiry/${id}/pdf/`,
    INTERESTS_GET: 'buyers/interests/list/',
    INTERESTS_OPTIONS: 'buyers/interests/options/',
    INTERESTS_SUBMIT: 'buyers/interests/submit/',
    SANITARYWARE_INQUIRY_CLICK: (productId) => `buyers/sanitaryware-product/${productId}/inquiry-click/`,
    TILE_INQUIRY_CLICK: (productId) => `buyers/tile-product/${productId}/inquiry-click/`,
    SANITARYWARE_INQUIRY_CLICK_LIST: 'accounts/sanitaryware-product/inquiry-click/list/',
    TILE_INQUIRY_CLICK_LIST: 'accounts/tile-product/inquiry-click/list/',
  },

  SELLERS: {
    SIGNUP: 'sellers/signup/',
    PROFILE: 'sellers/profile/',
    PROFILE_BY_ID: (sellerId) => `sellers/profile/${sellerId}/`,
    PROFILE_UPDATE: (sellerId) => `sellers/profile/${sellerId}/update/`,
    PROFILE_DELETE: 'sellers/profile/delete/',
    PROFILE_CHANGE_IMAGE: 'sellers/profile/changeimage/',
    PROFILE_ACTIVE_STATUS: (sellerId) => `sellers/profile/${sellerId}/activestatus/`,
    BUYER_LIST: 'sellers/buyer/list/',
    CATALOGS: 'sellers/catalogs/',
    CATALOGS_BY_SELLER: (sellerId) => `sellers/catalogs/${sellerId}/`,
    CATALOGS_UPLOAD: 'sellers/catalogs/upload/',
    CATALOGS_DELETE: (catalogId) => `sellers/catalogs/${catalogId}/delete/`,
    CATEGORY_LIST: 'sellers/category/list/',
    LIST: 'sellers/list/',
  },

  SANITARYWARE: {
    LIST: 'products/sanitaryware/list/',
    CREATE: 'products/sanitaryware/create/',
    DETAIL: (id) => `products/sanitaryware/${id}/detail/`,
    UPDATE: (id) => `products/sanitaryware/${id}/update/`,
    DELETE: (id) => `products/sanitaryware/${id}/delete/`,
    ACTIVATION_STATUS: (productId) => `products/sanitaryware/${productId}/activation-status/`,
    PUBLISH_STATUS: (productId) => `products/sanitaryware/${productId}/publish-status/`,
    IMAGES_LIST: (productId) => `products/sanitaryware/${productId}/images/list/`,
    IMAGES_UPLOAD: (productId) => `products/sanitaryware/${productId}/images/upload/`,
    IMAGES_DETAIL: (productId, imageId) => `products/sanitaryware/${productId}/images/detail/${imageId}/`,
    IMAGES_DELETE: (productId, imageId) => `products/sanitaryware/${productId}/images/delete/${imageId}/`,
    IMAGES_CHANGE_PRIMARY: (productId, imageId) => `products/sanitaryware/${productId}/images/change-primary/${imageId}/`,
    ATTRIBUTES_LIST: 'products/sanitaryware/attributes/list/',
    ATTRIBUTES_CREATE: 'products/sanitaryware/attributes/create/',
    ATTRIBUTES_DETAIL: (attrId) => `products/sanitaryware/attributes/${attrId}/detail/`,
    ATTRIBUTES_UPDATE: (attrId) => `products/sanitaryware/attributes/${attrId}/update/`,
    ATTRIBUTES_DELETE: (attrId) => `products/sanitaryware/attributes/${attrId}/delete/`,
    ATTRIBUTES_PREVIEW_UPDATE: (attrId) => `products/sanitaryware/attributes/${attrId}/preview-update/`,
    ATTRIBUTES_UNDO_DEPRECATION: (attrId) => `products/sanitaryware/attributes/${attrId}/undo-deprecation/`,
    TYPES_LIST: 'products/sanitaryware/types/list/',
    TYPES_CREATE: 'products/sanitaryware/types/create/',
    TYPES_UPDATE: (typeId) => `products/sanitaryware/types/${typeId}/update/`,
    TYPES_DELETE: (typeId) => `products/sanitaryware/types/${typeId}/delete/`,
    TYPES_UNDO_DEPRECATION: (typeId) => `products/sanitaryware/types/${typeId}/undo-deprecation/`,
    TYPES_ASSIGN_ATTRIBUTE: (typeId) => `products/sanitaryware/types/${typeId}/assign-attribute/`,
    TYPES_ASSIGN_MULTIPLE_ATTRIBUTES: (typeId) => `products/sanitaryware/types/${typeId}/assign-attribute/`,
    TYPES_REMOVE_ATTRIBUTE: (typeId) => `products/sanitaryware/types/${typeId}/remove-attribute/`,
    TYPES_FILTERS: (typeId) => `products/sanitaryware/types/${typeId}/filters/`,
  },

  TILES: {
    LIST: 'products/tiles/list/',
    CREATE: 'products/tiles/create/',
    DETAIL: (id) => `products/tiles/${id}/detail/`,
    UPDATE: (id) => `products/tiles/${id}/update/`,
    DELETE: (id) => `products/tiles/${id}/delete/`,
    ACTIVATION_STATUS: (productId) => `products/tiles/${productId}/activation-status/`,
    PUBLISH_STATUS: (productId) => `products/tiles/${productId}/publish-status/`,
    PDFS_LIST: (productId) => `products/tiles/${productId}/pdfs/list/`,
    PDFS_UPLOAD: (productId) => `products/tiles/${productId}/pdfs/upload/`,
    PDFS_DELETE: (productId, pdfId) => `products/tiles/${productId}/pdfs/delete/${pdfId}/`,
    SIZES_LIST: 'products/tiles/sizes/list/',
    SIZES_CREATE: 'products/tiles/sizes/create/',
    SIZES_UPDATE: (sizeId) => `products/tiles/sizes/${sizeId}/update/`,
    SIZES_DELETE: (sizeId) => `products/tiles/sizes/${sizeId}/delete/`,
    SIZES_UNDO_DEPRECATION: (sizeId) => `products/tiles/sizes/${sizeId}/undo-deprecation/`,
    TYPES_LIST: 'products/tiles/types/list/',
    TYPES_CREATE: 'products/tiles/types/create/',
    TYPES_UPDATE: (typeId) => `products/tiles/types/${typeId}/update/`,
    TYPES_DELETE: (typeId) => `products/tiles/types/${typeId}/delete/`,
    TYPES_UNDO_DEPRECATION: (typeId) => `products/tiles/types/${typeId}/undo-deprecation/`,
  },

  SOCIAL: {
    POSTS_LIST: 'social/post/list/',
    POSTS_CREATE: 'social/post/create/',
    POSTS_DETAIL: (postId) => `social/post/${postId}/detail/`,
    POSTS_UPDATE: (postId) => `social/post/${postId}/update/`,
    POSTS_DELETE: (postId) => `social/post/${postId}/delete/`,
    REVIEWS_LIST: (sellerId) => `social/sellers/${sellerId}/reviews/list/`,
    REVIEWS_CREATE: (sellerId) => `social/sellers/${sellerId}/review/`,
    REVIEWS_DELETE: (reviewId) => `social/reviews/${reviewId}/delete/`,
    FOLLOWERS_FOLLOW: (sellerId) => `social/sellers/${sellerId}/follow/`,
    FOLLOWERS_UNFOLLOW: (sellerId) => `social/sellers/${sellerId}/unfollow/`,
    BANNERS_LIST: 'social/advbanner/list/',
    BANNERS_CREATE: 'social/advbanner/create/',
    BANNERS_DETAIL: (bannerId) => `social/advbanner/${bannerId}/detail/`,
    BANNERS_DELETE: (bannerId) => `social/advbanner/${bannerId}/delete/`,
  },

  SUBSCRIPTIONS: {
    LIST: 'subscriptions/list/',
    LIST_EXPORT: 'subscriptions/list/export/',
    PLANS_LIST: 'subscriptions/plans/',
    PLANS_DETAIL: (planId) => `subscriptions/plans/${planId}/`,
    PLANS_CREATE: 'subscriptions/plans/create/',
    PLANS_UPDATE: (planId) => `subscriptions/plans/${planId}/`,
    PLANS_DELETE: (planId) => `subscriptions/plans/${planId}/`,
    BUYERS_LIST: 'subscriptions/buyers/',
    BUYERS_DETAIL: (buyerId) => `subscriptions/buyers/${buyerId}/`,
    SELLERS_LIST: 'subscriptions/sellers/',
    SELLERS_DETAIL: (sellerId) => `subscriptions/sellers/${sellerId}/`,
    PAYMENT_INITIATE: 'subscriptions/payment/initiate/',
    PAYMENT_VERIFY: 'subscriptions/payment/verify/',
    TRANSACTION_FAILED_LIST: 'subscriptions/transaction/failed/list/',
  },
};
export const buildApiUrl = (endpoint) => {
  return `${BASE_URL}${endpoint}`;
};
export const getEndpoint = (endpoint, ...params) => {
  if (typeof endpoint === 'function') {
    return endpoint(...params);
  }
  return endpoint;
};

export default API_ENDPOINTS; 